(function () {
  const HIDE_LOGO_FOR = '55158563504515';

  function currentVariant() {
    const v = new URLSearchParams(location.search).get('variant');
    return v || $('form[action*="/cart"] [name="id"]').val() || null;
  }

  function showhideBullets() {
    const v = currentVariant();

    $('.product-bullets').hide()
      .filter('[data-variant="' + v + '"]').show();

    if (!v) {
      $('.product-bullets,.stock-messaging,.atc-buttons').first().show();
    }

    $('.bottom-logo').toggle(v !== HIDE_LOGO_FOR);
  }

  // init + listeners
  showhideBullets();
  $(document).on('change', '.single-option-selector,select[name="id"]', showhideBullets);
  window.addEventListener('popstate', showhideBullets);
})();



// not in use
$(document).ready(function(){
  $('.keyadd').click(function(){
    if ($(this).hasClass('done')) { return false};
  	var id = $(this).attr('data-id');
    console.log(id);
    $(this).html('added').addClass('btn-primary AddToCart-product-template btn-disabled');
      itemAdd(id, null, 1, false, false)
  })
})

function itemAdd(variantId, properties, qty, openCart, reloadPage){
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: `/cart/add.js`,
        data: 
            {
                id: variantId,
                quantity: qty,
                properties: (properties) 
                    ? JSON.parse(properties) : null
            },
        error: function(data) {
            console.error(data);

            loadingBarTrigger('done');
        },
        success: function() {
            loadingBarTrigger('move');

            $.ajax({
                url: '/cart',
                dataType: 'html',
                error: function(data) {
                console.error(data);

                loadingBarTrigger('done');
            },
                success: function(data) {
                    let minicartContent = $('#minicart-content');
                    let cartItemsHtml = $(data).find('#cart-content #cart-items').html();

                    // insert or prepend cart HTML
                    (minicartContent.find('#cart-items').length)
                        ? minicartContent.find('#cart-items').html(cartItemsHtml)
                        : minicartContent.prepend(cartItemsHtml);

                    // remove giftbox content if exists
                    (minicartContent.find('#cart-giftbox .item-info').length)
                        ? minicartContent.find('#cart-giftbox .item-info').remove()
                        : '';

                    loadingBarTrigger('done');
                    cartTotalUpdate();

                    // open cart
                    (openCart && !html.is('#cart'))
                        ? minicartTrigger.trigger('click') : '';

                    (reloadPage)
                        ? location.reload() : '';
                }
            });
        }
    });
}


// ACCORDION
 const headers = document.querySelectorAll('.accordion-header');
    const bodies = document.querySelectorAll('.accordion-body');

    headers.forEach(header => {
      header.addEventListener('click', () => {
        const body = header.nextElementSibling;
        body.classList.toggle('open');
      });
    });

    function setInitialAccordionState() {
      const isDesktop = window.innerWidth >= 768;
      bodies.forEach(body => {
        // if (isDesktop) {
          body.classList.add('open');
        // } else {
          // body.classList.remove('open');
        // }
      });
    }

    // Run on load
    setInitialAccordionState();

    // Optional: Update on resize
    window.addEventListener('resize', setInitialAccordionState);



// sync the upsell select box with the variant select box
const waitForElements = () => {
  const selectA = document.querySelector("#variantsLabel"); // First one only
  const selectB = document.getElementById("SingleOptionSelector-product-template-bullets-0");

  if (!selectA || !selectB) {
    return false;
  }

  const syncByVisibleText = (source, target) => {
    const selectedText = source.options[source.selectedIndex].textContent.trim();

    for (let i = 0; i < target.options.length; i++) {
      if (target.options[i].textContent.trim() === selectedText) {
        if (target.selectedIndex !== i) {
          target.selectedIndex = i;
          target.dispatchEvent(new Event("change", { bubbles: true }));
          // console.log(`Synced: "${selectedText}"`);
        }
        break;
      }
    }
  };

  // 🧠 Initial sync: B -> A (SingleOptionSelector is the master)
  syncByVisibleText(selectB, selectA);

  // Two-way sync after initial load
  selectA.addEventListener("change", () => syncByVisibleText(selectA, selectB));
  selectB.addEventListener("change", () => syncByVisibleText(selectB, selectA));

  return true;
};

// MutationObserver to wait for elements to exist
const observer = new MutationObserver(() => {
  if (waitForElements()) {
    observer.disconnect(); // Stop watching once synced
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});







// FREE KEYRING FOR OVER £100
// document.addEventListener("DOMContentLoaded", () => {
//   const AUTO_ADD_VARIANT_ID = 55283621560707;
//   const PRICE_THRESHOLD = 10000; // £100
//   const POLL_INTERVAL = 3000; // check every 3 seconds

//   let lastCartState = {
//     hasAutoItem: null,
//     total: null
//   };

//   const log = (...args) => console.log("[Auto Add Debug]", ...args);

//   async function getCart() {
//     try {
//       const res = await fetch("/cart.js");
//       return await res.json();
//     } catch (err) {
//       // log("Error fetching cart:", err);
//       return null;
//     }
//   }

//   async function addProduct() {
//     // log("Adding product to cart");
//     try {
//       await fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id: AUTO_ADD_VARIANT_ID, quantity: 1 }),
//       });
//     } catch (err) {
//       // log("Error adding product:", err);
//     }
//   }

//   async function removeProduct(lineItemKey) {
//     // log("Removing product from cart");
//     try {
//       await fetch("/cart/change.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
//       });
//     } catch (err) {
//       // log("Error removing product:", err);
//     }
//   }

//   async function checkCart() {
//     const cart = await getCart();
//     if (!cart) return;

//     const total = cart.total_price;
//     const autoItem = cart.items.find(item => item.variant_id === AUTO_ADD_VARIANT_ID);
//     const hasAutoItem = Boolean(autoItem);

//     // log("Cart total:", total, "| Has auto item:", hasAutoItem);

//     // Avoid repeating the same action if nothing's changed
//     if (
//       total === lastCartState.total &&
//       hasAutoItem === lastCartState.hasAutoItem
//     ) return;

//     lastCartState = { total, hasAutoItem };

//     if (total >= PRICE_THRESHOLD && !hasAutoItem) {
//       await addProduct();
//     }

//     if (total < PRICE_THRESHOLD && hasAutoItem) {
//       await removeProduct(autoItem.key);
//     }
//   }

//   // Start polling every few seconds
//   setInterval(checkCart, POLL_INTERVAL);

//   // Run once on load
//   checkCart();
// });





// CODE TO HANDLE COMING SOON BTN CHANGES
(function ($) {
  var UPSellSel = '.lb-upsell-title';
  var priceSel = '.product_price';
  var BulletsSel = '.product-bullets:visible';
  var ComingSoonSel = '.coming-soon-note:visible';

  function hasComingSoonVisible() {
    var $visibleBullets = $(BulletsSel);
    if (!$visibleBullets.length) return false;
    if ($visibleBullets.find(ComingSoonSel).length) return true;
    var text = $visibleBullets.text().toLowerCase();
    return text.indexOf('coming soon') !== -1;
  }

  function updatePreorderBtnLabel() {
    var comingSoon = hasComingSoonVisible();
    $('.pre-order-btn[disabled]').each(function () {
      var $btn = $(this);
      var $text =
        $btn.find('.btn-text').first().length ? $btn.find('.btn-text').first() :
        $btn.find('[class*="AddToCartText"]').first().length ? $btn.find('[class*="AddToCartText"]').first() :
        $btn.find('span').first();

      if (comingSoon) {
        if ($text.length) {
          $text.text('Coming soon!');
        } else {
          $btn.text('Coming soon!');
        }
      } else {
        // reset back to Sold out / Pre-order if not coming soon
        if ($text.length) {
          $text.text('Sold out');
        } else {
          $btn.text('Sold out');
        }
      }
    });
  }

  function applyVisibility() {
    var showStuff = !hasComingSoonVisible();
    $(UPSellSel).toggle(showStuff);
    $(priceSel).toggle(showStuff);
    updatePreorderBtnLabel();
  }

  function burst() {
    applyVisibility();
    setTimeout(applyVisibility, 50);
    setTimeout(applyVisibility, 150);
    setTimeout(applyVisibility, 300);
  }

  function observeDom() {
    var root = document.querySelector('.product-template__container') || document.body;
    if (!('MutationObserver' in window) || !root) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(burst, 30);
    }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['style','class'] });
  }

  function hookEvents() {
    $(document).on('variant:change variant:changed product:variant-change', burst);
    $(document).on('change', 'select[name="id"]', burst);
    $(document).on('click', '[data-option-position],[data-option-index],.swatch input,.swatch-element input', function(){ setTimeout(burst, 0); });

    var _ps = history.pushState, _rs = history.replaceState;
    if (_ps) history.pushState = function(){ _ps.apply(this, arguments); $(window).trigger('location:change'); };
    if (_rs) history.replaceState = function(){ _rs.apply(this, arguments); $(window).trigger('location:change'); };
    $(window).on('popstate location:change', burst);
  }

  $(function () {
    burst();
    hookEvents();
    observeDom();
  });
})(jQuery);

// UK / NON-UK MESSAGING
document.addEventListener("DOMContentLoaded", () => {
  const nonUkMessages = document.querySelectorAll(".non-uk-message");
  const ukOnlyMessages = document.querySelectorAll(".uk-only-message");

  if (!nonUkMessages.length && !ukOnlyMessages.length) return;

  // Default: assume UK
  nonUkMessages.forEach(el => el.style.display = "none");
  ukOnlyMessages.forEach(el => el.style.display = "block");

  const STORAGE_KEY = "user_country";
  const cachedCountry = localStorage.getItem(STORAGE_KEY);

  const updateMessages = country => {
    const isUK = country === "GB";

    nonUkMessages.forEach(el => {
      el.style.display = isUK ? "none" : "block";
    });

    ukOnlyMessages.forEach(el => {
      el.style.display = isUK ? "block" : "none";
    });
  };

  // Use cached value if available
  if (cachedCountry) {
    updateMessages(cachedCountry);
    return;
  }

  // Otherwise fetch and cache
  fetch("https://ipapi.co/json/")
    .then(res => res.json())
    .then(data => {
      if (data?.country) {
        localStorage.setItem(STORAGE_KEY, data.country);
        updateMessages(data.country);
      }
    })
    .catch(() => {
      // Fail silently — default stays UK
    });
});



// UK DISPATCH CUT-OFF COUNTDOWN (UK only, in-stock selected variant only)
document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector(".uk-cutoff-countdown");
  if (!el) return;

  /* ===============================
     SETTINGS
  =============================== */
  const TIMEZONE = "Europe/London";
  const CUTOFF_HOUR = 15; // 3pm
  const START_HOUR = 6;   // 6am
  const STORAGE_KEY = "user_country"; // reuse existing key
  const CACHE_TTL = 1000 * 60 * 60 * 24 * 7; // optional (only used if you store ts too)
  const REFRESH_INTERVAL = 30 * 1000; // 30s

  let isUk = false;
  let variantsById = {};
  let lastVariantId = null;

  /* ===============================
     COUNTRY (reuses existing cache)
  =============================== */
  async function getCountry() {
    // If you already store just "GB" in user_country, use it
    const cached = localStorage.getItem(STORAGE_KEY);
    if (cached) return cached;

    // Otherwise fetch and cache (matches your existing behaviour)
    try {
      const res = await fetch("https://ipapi.co/json/");
      const data = await res.json();
      const country = data?.country || data?.country_code || null;

      if (country) localStorage.setItem(STORAGE_KEY, country);
      return country;
    } catch (e) {
      return null; // UK-only: hide if lookup fails
    }
  }

  /* ===============================
     PRODUCT / VARIANT LOOKUP
  =============================== */
  function loadVariantsFromJson() {
    const jsonEl = document.querySelector('script[id^="ProductJson-"][type="application/json"]');
    if (!jsonEl) return;

    try {
      const productData = JSON.parse(jsonEl.textContent);
      if (!productData?.variants?.length) return;

      variantsById = {};
      productData.variants.forEach(v => {
        variantsById[String(v.id)] = v;
      });
    } catch (e) {}
  }

  function getSelectedVariantId() {
    const input =
      document.querySelector('form[action^="/cart/add"] [name="id"]') ||
      document.querySelector('[name="id"]');

    return input ? String(input.value || "") : null;
  }

  function isSelectedVariantAvailable() {
    const id = getSelectedVariantId();
    if (id && variantsById[id]) return !!variantsById[id].available;

    // Optional fallback: if you output data-initial-available
    if (el.dataset.initialAvailable) return el.dataset.initialAvailable === "true";

    return false;
  }

  /* ===============================
     LONDON TIME HELPERS
  =============================== */
  function getLondonParts(date = new Date()) {
    const fmt = new Intl.DateTimeFormat("en-GB", {
      timeZone: TIMEZONE,
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });

    const parts = Object.fromEntries(fmt.formatToParts(date).map(p => [p.type, p.value]));
    return {
      weekday: parts.weekday, // Mon..Sun
      hour: Number(parts.hour),
      minute: Number(parts.minute),
      second: Number(parts.second)
    };
  }

  function isWithinDispatchWindow(t) {
    // Mon–Fri only
    if (t.weekday === "Sat" || t.weekday === "Sun") return false;

    // Show again 6am
    if (t.hour < START_HOUR) return false;

    // Hide after 3pm (15:00:00 is still valid; 15:00:01 hides)
    if (t.hour > CUTOFF_HOUR) return false;
    if (t.hour === CUTOFF_HOUR && (t.minute > 0 || t.second > 0)) return false;

    return true;
  }

  function msUntilCutoff(t) {
    const nowSec = (t.hour * 3600) + (t.minute * 60) + t.second;
    const cutoffSec = CUTOFF_HOUR * 3600; // 15:00:00
    return Math.max(0, (cutoffSec - nowSec) * 1000);
  }

  function formatCountdown(ms) {
    const totalMins = Math.max(0, Math.floor(ms / 60000));
    const h = Math.floor(totalMins / 60);
    const m = totalMins % 60;
    return h > 0 ? `${h}h ${m}m` : `${m}m`;
  }

  /* ===============================
     RENDER
  =============================== */
  function hide() {
    el.style.display = "none";
  }

  function show(text) {
    el.textContent = text;
    el.style.display = "block";
  }

  function update() {
    if (!isUk) return hide();
    if (!isSelectedVariantAvailable()) return hide();

    const t = getLondonParts();
    if (!isWithinDispatchWindow(t)) return hide();

    const timeText = formatCountdown(msUntilCutoff(t));
    show(`💨 Order in the next ${timeText} for delivery as early as tomorrow`);
  }

  /* ===============================
     LISTENERS
  =============================== */
  function attachVariantListeners() {
    const form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return;

    form.addEventListener("change", function () {
      setTimeout(update, 50);
    });

    form.addEventListener("click", function () {
      setTimeout(update, 50);
    });
  }

  function startVariantPolling() {
    setInterval(function () {
      const currentId = getSelectedVariantId();
      if (currentId && currentId !== lastVariantId) {
        lastVariantId = currentId;
        update();
      }
    }, 500);
  }

  /* ===============================
     INIT
  =============================== */
  (async function init() {
    hide();

    loadVariantsFromJson();
    attachVariantListeners();
    startVariantPolling();

    const country = await getCountry();
    isUk = (country === "GB");

    update();
    setInterval(update, REFRESH_INTERVAL);
  })();
});





// STICKY PRODUCT NAV
(() => {
  const nav = document.querySelector('.pdp-sticky-nav');
  if (!nav) return;

  const links = [...nav.querySelectorAll('.pdp-sticky-link')];
  const sections = links
    .map(a => document.querySelector(a.getAttribute('href')))
    .filter(Boolean);

  if (!sections.length) return;

  const header = document.querySelector('header'); // tweak selector if your theme uses something else

  // One buffer to rule them all 😄
  const EXTRA_BUFFER = 100; // <-- increase/decrease to taste

  const getOffset = () => {
    const headerH = header ? header.offsetHeight : 0;
    return headerH + nav.offsetHeight + 40; // base spacing
  };

  let lastActiveId = null;

const setActive = (id) => {
  if (id === lastActiveId) return; // prevents constant nudging
  lastActiveId = id;

  links.forEach(l =>
    l.classList.toggle('is-active', l.getAttribute('href') === `#${id}`)
  );

  // Auto-scroll the tab strip only if needed (NO scrollIntoView)
  const container = nav.querySelector('.pdp-sticky-nav__inner');
  const active = nav.querySelector('.pdp-sticky-link.is-active');
  if (!container || !active) return;

  const cRect = container.getBoundingClientRect();
  const aRect = active.getBoundingClientRect();

  const padding = 24; // how much space you want around the active tab

  const isOutLeft = aRect.left < cRect.left + padding;
  const isOutRight = aRect.right > cRect.right - padding;

  if (isOutLeft || isOutRight) {
    const left =
      active.offsetLeft - (container.clientWidth / 2) + (active.clientWidth / 2);

    container.scrollTo({
      left,
      behavior: 'auto' // key: prevents jank while page is scrolling
    });
  }
};

  // ---- Click to scroll with buffer ----
  links.forEach(a => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      const target = document.querySelector(id);
      if (!target) return;

      e.preventDefault();

      const y =
        target.getBoundingClientRect().top +
        window.scrollY -
        (getOffset() + EXTRA_BUFFER);

      window.scrollTo({ top: y, behavior: 'smooth' });
      history.replaceState(null, '', id);
      a.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  });

  // ---- Highlight active section on scroll (stable + throttled) ----
  let ticking = false;

  const update = () => {
    ticking = false;

    const marker = getOffset() + 120;
    let current = sections[0];

    for (const s of sections) {
      const top = s.getBoundingClientRect().top;
      if (top <= marker) current = s;
      else break;
    }

    setActive(current.id);
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  // Initial state
  onScroll();

  // If page loads with a hash, jump to it with buffer
  if (location.hash) {
    const target = document.querySelector(location.hash);
    if (target) {
      setTimeout(() => {
        const y =
          target.getBoundingClientRect().top +
          window.scrollY -
          (getOffset() + EXTRA_BUFFER);

        window.scrollTo({ top: y });
        onScroll();
      }, 50);
    }
  }
})();



(() => {
  const nav = document.querySelector('.pdp-sticky-nav');
  if (!nav) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      nav.classList.add('is-visible');
    } else {
      nav.classList.remove('is-visible');
    }
  });
})();


// $(document).ready(function(){
// setTimeout(()=>{
//   $('.ppcse-m-table input[type="checkbox"]').first().prop('checked', false)
//   $('table.ppcse-m-table > tr:nth-child(2)').first().hide();
// }, 500)
// });


// FIXES THE COW BOOKING APP IN CART
document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/cart')) return;

  document.querySelectorAll('.item__meta').forEach(function (el) {
    const text = el.textContent.replace(/\s+/g, ' ').trim();

    if (!text.includes('__cow_internal')) return;

    const dateMatch = text.match(/Date:\s*(.*?)(?=Which product do you need help installin|__cow_|$)/i);
    const productMatch = text.match(/Which product do you need help installin\.\.\.:\s*(.*?)(?=__cow_|$)/i);

    let html = '';

    if (dateMatch && dateMatch[1]) {
      html += '<div style="font-size:12px; color:#aaa; font-style:italic;"><strong>Date:</strong> ' + dateMatch[1].trim() + '</div>';
    }

    if (productMatch && productMatch[1]) {
      html += '<div style="font-size:12px; color:#aaa; font-style:italic;"><strong>Which product do you need help installing:</strong> ' + productMatch[1].trim() + '</div>';
    }

    el.innerHTML = html;
  });
});